export enum AHJType {
  CITY = "city",
  COUNTY = "county",
  SPECIAL = "special",
}

export interface IPermittingRequirements {
  slabUpliftTest: boolean;
  slabCoreTest: boolean;
  adaPlans: boolean;
  photometricPlans: boolean;
  egressPlans: boolean;
  smokeVentInspections: boolean;
  fpeStamp: boolean;
  weightSigns: boolean;
  flueKeepersPalletStops: boolean;
  keepClearsStickers: boolean;
  fireSignsCommoditySigns: boolean;
}

export interface IAHJ {
  _id: string;
  name: string;
  type: AHJType;
  state: string;
  permittingRequirements: IPermittingRequirements;
  requiredSubmittalProcess?: string;
  avgReviewTimeline?: string;
  expeditedServices?: string;
  expeditedServicesCost?: string;
  createdBy: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  updatedBy?: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface AHJFormData {
  name: string;
  type: AHJType;
  state: string;
  permittingRequirements: IPermittingRequirements;
  requiredSubmittalProcess?: string;
  avgReviewTimeline?: string;
  expeditedServices?: string;
  expeditedServicesCost?: string;
}
